import React from "react";
import AttachFileOutlinedIcon from "@mui/icons-material/AttachFileOutlined";
import { styles } from "./AttachmentSelector.styles";
import { IAttachmentSelector } from "./AttachmentSelector.types";

const AttachmentSelector = ({
  openImageFileSelector,
}: IAttachmentSelector.IAttachmentSelectorProps) => {
  return (
    <AttachFileOutlinedIcon
      className={styles.attachmentIcon}
      onClick={openImageFileSelector}
    />
  );
};

export default AttachmentSelector;
